export default (props, {
  rhythm
}) => ({
  category: {
    marginBottom: rhythm(1)
  }
})
